// 错误消息提示器，需要设置
let messager;

// 错误消息提示器设置
export function setMessager(msger) {
  messager = msger;
}

export { messager };
